import { useState } from 'react';
import {
  useLazyGetShopReportOwnerReplyQuery,
  useLazyGetServiceReportOwnerReplyQuery,
} from '../../features/report/reportApiSlice';

export const useReportReply = () => {
  const [lgShow, setLgShow] = useState(false);
  const [singledata, setSingledata] = useState(null);
  const [isQueryLoading, setIsQueryLoading] = useState(false);

  const [triggerShopReport] = useLazyGetShopReportOwnerReplyQuery();
  const [triggerServiceReport] = useLazyGetServiceReportOwnerReplyQuery();

  const dataFetch = async (shopId, reportId) => {
    setIsQueryLoading(true);
    setLgShow(true);
    try {
      const res = await triggerShopReport({ shopId, reportId }).unwrap();
      setSingledata(res);
    } catch (err) {
      setSingledata(null);
    } finally {
      setIsQueryLoading(false);
    }
  };

  const servicedataFetch = async (serviceId, reportId) => {
    setIsQueryLoading(true);
    setLgShow(true);
    try {
      const res = await triggerServiceReport({ serviceId, reportId }).unwrap();
      setSingledata(res);
    } catch (err) {
      setSingledata(null);
    } finally {
      setIsQueryLoading(false);
    }
  };

  return {
    lgShow,
    setLgShow,
    singledata,
    isQueryLoading,
    dataFetch,
    servicedataFetch,
  };
};

export default useReportReply;
